// @flow
import { AxiosRequestConfig } from 'axios'

/**
 * Specify version for GET content request
 * @param {string} version - version for content call
 * @return {function(AxiosRequestConfig): AxiosRequestConfig} - returns changed axios config
 */
export default (version: string) => (requestConfig: AxiosRequestConfig) => {
  if (version && requestConfig.method === 'get' && new RegExp('^(/)?content/').test(requestConfig.url)) {
    const url: URL = new URL(requestConfig.url, requestConfig.baseURL)
    if (url.search) {
      url.search = `${url.search}&version=${version}`
    } else {
      url.search = `?version=${version}`
    }
    requestConfig.headers['Cache-Control'] = 'no-cache'
    requestConfig.url = url.href
  }
  return requestConfig
}
